var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C-4.10938e-08 23.7578 0.543181 26.4885 1.59853 29.0364C2.65388 31.5842 4.20073 33.8992 6.15076 35.8492C8.10079 37.7993 10.4158 39.3461 12.9636 40.4015C15.5115 41.4568 18.2422 42 21 42C23.7578 42 26.4885 41.4568 29.0364 40.4015C31.5842 39.3461 33.8992 37.7993 35.8492 35.8492C37.7993 33.8992 39.3461 31.5842 40.4015 29.0364C41.4568 26.4885 42 23.7578 42 21C42 18.2422 41.4568 15.5115 40.4015 12.9636C39.3461 10.4158 37.7993 8.10079 35.8492 6.15076C33.8992 4.20073 31.5842 2.65388 29.0364 1.59853C26.4885 0.543181 23.7578 0 21 0C18.2422 0 15.5115 0.543181 12.9636 1.59853C10.4158 2.65388 8.10079 4.20073 6.15076 6.15076C4.20073 8.10079 2.65388 10.4158 1.59853 12.9636C0.543181 15.5115 -4.10938e-08 18.2422 0 21Z",
    fill: "var(--brand-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0098 12H21.0371H21.0098Z",
    fill: "var(--brand-color)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0098 12H21.0371",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.7891V30.5148",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5cfc02ecb56bd7bd6793553fc85363e5.svg";
export { ForwardRef as ReactComponent };